module.exports = __webpack_public_path__ + "static/media/vk-logo.8788bd5e.svg";